import { render, staticRenderFns } from "./WootKeyShortcutModal.vue?vue&type=template&id=4a52dd26&scoped=true"
import script from "./WootKeyShortcutModal.vue?vue&type=script&setup=true&lang=js"
export * from "./WootKeyShortcutModal.vue?vue&type=script&setup=true&lang=js"
import style0 from "./WootKeyShortcutModal.vue?vue&type=style&index=0&id=4a52dd26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a52dd26",
  null
  
)

export default component.exports